import * as React from "react"
const ApplePears = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#73AF3C"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.737 13.251C18.737 10.903 20.652 9 23 9s4.263 1.903 4.263 4.251c0 1.057.197 2.104.58 3.089l1.028 2.635C30.376 22.835 27.53 27 23.387 27h-.774c-4.142 0-6.99-4.165-5.484-8.025l1.027-2.635c.384-.985.58-2.032.58-3.089Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M23 5c-.5 2-.5 2.5 0 4"
    />
    <path
      fill="#D24F32"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11 26.065c1.35 0 2.475.935 3.6.935 2.7 0 5.4-7.058 5.4-10.782a4.294 4.294 0 0 0-1.364-3.017A4.468 4.468 0 0 0 15.5 12c-1.998 0-3.6 1.27-4.5 1.764-.9-.494-2.502-1.764-4.5-1.764a4.459 4.459 0 0 0-3.139 1.197A4.285 4.285 0 0 0 2 16.218C2 19.942 4.7 27 7.4 27c1.125 0 2.25-.935 3.6-.935Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 9c1.5.3 3 1.2 3 3"
    />
    <path
      fill="#306203"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 8h2v1.667c0 .884-.421 1.732-1.172 2.357-.75.625-1.767.976-2.828.976h-2v-1.667c0-.884.421-1.732 1.172-2.357C11.922 8.351 12.939 8 14 8Z"
    />
  </svg>
)
export default ApplePears
